import { Badge } from '@/components/ui/badge';
import { Tag } from 'lucide-react';
import { PromoCode } from '@/contracts/promoCodes';
import { calculateDaysRemaining } from '@/data/promoCodes';

interface PromoCodeBadgeProps {
  promo: PromoCode;
  className?: string;
}

export const PromoCodeBadge = ({ promo, className = '' }: PromoCodeBadgeProps) => {
  const daysRemaining = calculateDaysRemaining(promo.expires_at);
  const isUrgent = daysRemaining !== null && daysRemaining <= 3;
  
  return (
    <Badge 
      variant="secondary" 
      className={`
        ${promo.is_exclusive ? 'bg-primary text-primary-foreground' : 'bg-secondary text-secondary-foreground'}
        ${isUrgent ? 'animate-pulse' : ''}
        font-semibold
        ${className}
      `}
    >
      <Tag className="h-3 w-3 mr-1" />
      {promo.is_exclusive ? 'Exclusive Deal' : 'Promo Available'}
    </Badge>
  );
};
